/*eslint-disable*/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
// import {  useNavigate } from 'react-router-dom';
import Form from "react-bootstrap/Form";
import { FaUserAlt, FaLock, FaPhoneAlt, FaMapMarkedAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import { FiArrowRight } from "react-icons/fi";
import { api_url } from "../../Constants/web_services";
import { useDispatch } from "react-redux";
import { setSignedIn, setUserData } from "../../Redux/UserSlice";
import Swal from "sweetalert2";

function HeaderModal({ show, onHide }) {
  const dispatch = useDispatch();
  const [emailLogin, setEmailLogin] = useState("");
  const [emailForgot, setEmailForgot] = useState("");
  const [passwordLogin, setPasswordLogin] = useState("");
  const [error, setError] = useState("");
  const [address, setAddress] = useState("");
  const [username, setUsername] = useState("");
  const [contact, setContact] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isPasswordMatch, setIsPasswordMatch] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [data, setData] = useState(null);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const validateForm = () => password === confirmPassword;

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(api_url + `/api/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ email: emailLogin, password: passwordLogin })
      });

      const res = await response.json();

      if (res?.status === "success") {
        dispatch(setSignedIn(true));
        dispatch(setUserData(res?.user));
        localStorage.setItem("token", res?.token);

        setEmailLogin("");
        setPasswordLogin("");
        onHide();
      } else {
        setError(res?.message || "Invalid Credentials");
      }
    } catch (err) {
      setError("Network error");
    }
  };

  const handleCheckCode = async (e) => {
    e.preventDefault();

    await fetch(api_url + `/api/user-check-code/${emailForgot}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((result) => {
        setData(result);
        onHide("");
        setEmailForgot("");
        Swal.fire({
          icon: "success",
          title: "Mail sent",
          text: "Your email has been sent successfully.",
          timer: 2000,
          showConfirmButton: false,
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Mail not sent",
          text: "Something went wrong.",
          timer: 2000,
          showConfirmButton: false,
        });
      });
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    const registrationData = {
      username,
      contact,
      address,
      email,
      password,
      confirm_password: password,
    };

    try {
      const response = await fetch(api_url + `/api/user-register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(registrationData),
      });

      if (response.ok) {
        const responseData = await response.json();
        setUsername("");
        setContact("");
        setAddress("");
        setEmail("");
        setPassword("");
        setConfirmPassword("");
        onHide("");
      } else {
        // Handle registration error, e.g., show error message
        console.error("Registration failed");
      }
    } catch (error) {
      // Handle network or other errors
      console.error("Error during registration", error);
    }
  };

  const passwordMatch = () => {
    if (password?.length > 0) {
      if (password === confirmPassword) {
        setIsPasswordMatch(true);
        return;
      }
      setIsPasswordMatch(false);
    }
    setIsPasswordMatch(false);
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(api_url + `/api/userforgotpassword`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({ email: emailForgot }),
      });
      let res = await response.json();
      if (res?.status === "success") {
        setEmailForgot("");
        onHide();
      } else {
        setError("Invalid Credentials");
      }
    } catch (err) {
      setError("error");
    }
  };
  return (
    <>
      <div className="">
        <Modal
          className="auth-modal"
          onHide={onHide}
          show={show}
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Tab.Container
            id="left-tabs-example"
            defaultActiveKey="first"
            style={{ minWidth: "406px !important" }}
          >
            <Nav className="flex-column ">
              <Modal.Header className="border-0 minwidth-498" closeButton>
                <Modal.Title
                  id="contained-modal-title-vcenter"
                  className="w-100 nav d-flex justify-content-around align-items-center border-bottom pb-3 border-022279 border-3"
                >
                  <Nav.Item className="">
                    <Nav.Link
                      eventKey="first"
                      className="text-decoration-none active text-022279"
                    >
                      Login
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="">
                    <Nav.Link
                      eventKey="second"
                      className="text-decoration-none text-022279"
                    >
                      Sign up
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="">
                    <Nav.Link
                      eventKey="third"
                      className="text-decoration-none text-danger "
                      style={{ fontSize: "18px" }}
                    >
                      Forget Password
                    </Nav.Link>
                  </Nav.Item>
                </Modal.Title>
              </Modal.Header>
            </Nav>

            <Tab.Content>
              <Tab.Pane eventKey="first">
                <Modal.Body>
                  <Form onSubmit={handleLogin}>
                    {error && (
                      <div className="text-danger row justify-content-center pb-2">
                        {error}
                      </div>
                    )}

                    <div className="input-group mb-3 p-1">
                      <span
                        className="input-group-text  bg-white text-muted border-dee2e6"
                        id="basic-addon1"
                      >
                        <FaUserAlt />
                      </span>
                      <input
                        type="text"
                        value={emailLogin}
                        onChange={(e) => setEmailLogin(e.target.value)}
                        className="form-control border-start-0 border-dee2e6 box-shadow-none"
                        placeholder="Email"
                        // aria-label="Username"
                        aria-describedby="basic-addon1"
                      />
                    </div>

                    <div className="input-group mb-3 p-1">
                      <span
                        className="input-group-text  bg-white text-muted border-dee2e6"
                        id="basic-addon1"
                      >
                        <FaLock />
                      </span>
                      <input
                        type={showPassword ? "text" : "password"}
                        value={passwordLogin}
                        onChange={(e) => setPasswordLogin(e.target.value)}
                        className="form-control border-start-0 box-shadow-none border-dee2e6"
                        placeholder="Password"
                        // aria-label="Username"
                        aria-describedby="basic-addon1"
                      />
                      <span
                        className="input-group-text  bg-white text-muted border-dee2e6"
                        id="basic-addon1"
                      >
                        <i
                          onClick={toggleShowPassword}
                          className={`${showPassword ? "fa fa-eye " : "fa fa-eye-slash"
                            }`}
                        ></i>
                      </span>
                    </div>

                    {/* <Form.Group className="mb-3 d-sm-flex justify-content-between" controlId="formBasicCheckbox">
                                        <Form.Check type="checkbox" label="Keep me logged" />
                                        <Link to="/" className='text-decoration-none '>Forgot Password</Link>
                                    </Form.Group> */}
                    <div className="d-grid m-3 ">
                      <Button variant="warning" type="submit">
                        Submit
                      </Button>
                    </div>
                  </Form>
                </Modal.Body>
              </Tab.Pane>

              <Tab.Pane eventKey="second">
                <Modal.Body>
                  <Form onSubmit={handleRegister}>
                    <div className="input-group mb-3">
                      <span
                        className="input-group-text border-end-0 bg-white text-muted border-dee2e6"
                        id="basic-addon1"
                      >
                        <FaUserAlt />
                      </span>
                      <input
                        className="form-control border-start-0 border-dee2e6 box-shadow-none"
                        placeholder="Username"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                      />
                    </div>
                    <div className="input-group mb-3">
                      <span
                        className="input-group-text border-end-0 bg-white text-muted border-dee2e6"
                        id="basic-addon1"
                      >
                        <FaPhoneAlt />
                      </span>
                      <input
                        value={contact}
                        onChange={(e) => setContact(e.target.value)}
                        type="number"
                        className="form-control border-start-0 border-dee2e6 box-shadow-none"
                        placeholder="Phone"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                      />
                    </div>
                    <div className="input-group mb-3">
                      <span
                        className="input-group-text border-end-0 bg-white text-muted border-dee2e6"
                        id="basic-addon1"
                      >
                        <FaMapMarkedAlt />
                      </span>
                      <input
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        type="text"
                        className="form-control border-start-0 border-dee2e6 box-shadow-none"
                        placeholder="Address"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                      />
                    </div>
                    <div className="input-group mb-3">
                      <span
                        className="input-group-text border-end-0 bg-white text-muted border-dee2e6"
                        id="basic-addon1"
                      >
                        <MdEmail />
                      </span>
                      <input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"
                        className="form-control border-start-0 border-dee2e6 box-shadow-none"
                        placeholder="Email"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                      />
                    </div>
                    <div className="input-group mb-3">
                      <span
                        className="input-group-text border-end-0 bg-white text-muted border-dee2e6"
                        id="basic-addon1"
                      >
                        <FaLock />
                      </span>
                      <input
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyUp={passwordMatch}
                        type={showPassword ? "text" : "password"}
                        className={`form-control border-start-0 box-shadow-none border-dee2e6 ${isPasswordMatch === false ? "border-danger" : ""
                          } `}
                        placeholder="Password"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                      />
                      <span
                        className="input-group-text border-end-0 bg-white text-muted border-dee2e6"
                        id="basic-addon1"
                      >
                        <i
                          onClick={toggleShowPassword}
                          className={`${showPassword ? "fa fa-eye " : "fa fa-eye-slash"
                            }`}
                        ></i>
                      </span>
                    </div>
                    <div className="input-group mb-3">
                      <span
                        className="input-group-text border-end-0 bg-white text-muted border-dee2e6"
                        id="basic-addon1"
                      >
                        <FaLock />
                      </span>
                      <input
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        onKeyUp={passwordMatch}
                        type={showPassword ? "text" : "password"}
                        className={`form-control border-start-0 box-shadow-none border-dee2e6 ${isPasswordMatch === false ? "border-danger" : ""
                          }`}
                        placeholder="Confirm Password"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                      />
                      <span
                        className="input-group-text border-end-0 bg-white text-muted border-dee2e6"
                        id="basic-addon1"
                      >
                        <i
                          onClick={toggleShowPassword}
                          className={`${showPassword ? "fa fa-eye " : "fa fa-eye-slash"
                            }`}
                        ></i>
                      </span>
                    </div>
                    {/* <div className="form-check">
                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                        <label className="form-check-label" for="flexCheckDefault">
                                            I've read and agree with your <Link to="/" className='text-decoration-none '>Privacy Policy</Link>  and <Link to="/" className='text-decoration-none '>Terms & Conditions</Link>
                                        </label>
                                    </div> */}
                    {/* <Form.Group className="mb-3 d-flex justify-content-between" controlId="formBasicCheckbox">
                                        <Form.Check type="checkbox" label="Keep me logged" />
                                        <Link to="/" className='text-decoration-none '>Forgot Password</Link>
                                    </Form.Group> */}
                    <div className="d-grid m-3 ">
                      <Button variant="warning" type="submit">
                        Submit <FiArrowRight />
                      </Button>
                    </div>
                  </Form>
                </Modal.Body>
              </Tab.Pane>

              <Tab.Pane eventKey="third">
                <Modal.Body>
                  <Form
                    // onSubmit={handleForgotPassword}
                    onSubmit={handleCheckCode}
                  >
                    {/* {error && <div className="text-danger row justify-content-center pb-2">{error}</div>} */}

                    <div className="input-group mb-3 p-1">
                      <span
                        className="input-group-text border-end-0 bg-white text-muted border-dee2e6"
                        id="basic-addon1"
                      >
                        <FaUserAlt />
                      </span>
                      <input
                        type="text"
                        value={emailForgot}
                        onChange={(e) => setEmailForgot(e.target.value)}
                        className="form-control border-start-0 border-dee2e6 box-shadow-none"
                        placeholder="Email"
                        // aria-label="Username"
                        aria-describedby="basic-addon1"
                      />
                    </div>

                    <div className="d-grid m-3 ">
                      <Button variant="warning" type="submit">
                        Submit
                      </Button>
                    </div>
                  </Form>
                </Modal.Body>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Modal>
      </div>
    </>
  );
}

export default HeaderModal;
